export const relationship_to_hh_options = [
	{
		value: "reletohh_head",
		label: "Head",
	},
	{
		value: "reletohh_spouse",
		label: "Spouse",
	},
	{
		value: "reletohh_daughter",
		label: "Son/Daughter",
	},
	{
		value: "reletohh_brotherlaw",
		label: "Brother-in-law",
	},
	{
		value: "reletohh_sisterlaw",
		label: "Sister-in-law",
	},
	{
		value: "reletohh_law",
		label: "Son-in-law/Daughter-in-law",
	},
	{
		value: "reletohh_grandchildren",
		label: "Grandchildren",
	},
	{
		value: "reletohh_parents",
		label: "Parents",
	},
	/* 	{
		value: "reletohh_relatives",
		label: "Other relatives, specify",
	}, */
	{
		value: "reletohh_boy",
		label: "Housemaid/boy",
	},
	/* {
		value: "reletohh_specify",
		label: "Others, specify",
	}, */
];

export const ethnics = [
	{ value: "adasen", label: "Adasen" },
	{ value: "agtaalabatisland", label: "Agta, Alabat Island" },
	{ value: "agtacamarinesnorte", label: "Agta, Camarines Norte" },
	{ value: "agtacasigurandumagat", label: "Agta, Casiguran Dumagat" },
	{ value: "agtacentralcagayan", label: "Agta, Central Cagayan" },
	{ value: "agtadicamay", label: "Agta, Dicamay" },
	{ value: "agtadupaninan", label: "Agta, Dupaninan" },
	{ value: "agtaisarog", label: "Agta, Isarog" },
	{ value: "agtamt.iraya", label: "Agta, Mt. Iraya" },
	{ value: "agtamt.iriga", label: "Agta, Mt. Iriga" },
	{ value: "agtaumiraydumaget", label: "Agta, Umiray Dumaget" },
	{ value: "agtavillaviciosa", label: "Agta, Villaviciosa" },
	{ value: "aklanon", label: "Aklanon" },
	{ value: "alangan", label: "Alangan" },
	{ value: "altanorthern", label: "Alta, Northern" },
	{ value: "altasouthern", label: "Alta, Southern" },
	{ value: "amerasian", label: "Amerasian" },
	{ value: "ati", label: "Ati" },
	{ value: "attafaire", label: "Atta, Faire" },
	{ value: "attapamplona", label: "Atta, Pamplona" },
	{ value: "attapudtol", label: "Atta, Pudtol" },
	{ value: "aytaabellen", label: "Ayta, Abellen" },
	{ value: "aytaambala", label: "Ayta, Ambala" },
	{ value: "aytabataan", label: "Ayta, Bataan" },
	{ value: "aytamag-anchi", label: "Ayta, Mag-Anchi" },
	{ value: "aytamag-indi", label: "Ayta, Mag-Indi" },
	{ value: "aytasorsogon", label: "Ayta, Sorsogon" },
	{ value: "aytatayabas", label: "Ayta, Tayabas" },
	{ value: "b'laandavao", label: "B'laan, Davao" },
	{ value: "b'laankoronadal", label: "B'laan, Koronadal" },
	{ value: "b'laansarangani", label: "B'laan, Sarangani" },
	{ value: "badjao", label: "Badjao" },
	{ value: "bagobo", label: "Bagobo" },
	{ value: "balangao", label: "Balangao" },
	{ value: "balangingi", label: "Balangingi" },
	{ value: "bangon", label: "Bangon" },
	{ value: "bantoanon", label: "Bantoanon" },
	{ value: "banwaon", label: "Banwaon" },
	{ value: "batak", label: "Batak" },
	{ value: "bicolanoalbay", label: "Bicolano, Albay" },
	{ value: "bicolanocentral", label: "Bicolano, Central" },
	{ value: "bicolanoiriga", label: "Bicolano, Iriga" },
	{
		value: "bicolanonortherncatanduanes",
		label: "Bicolano, Northern Catanduanes",
	},
	{
		value: "bicolanosoutherncatanduanes",
		label: "Bicolano, Southern Catanduanes",
	},
	{ value: "binukid", label: "Binukid" },
	{ value: "boholano", label: "Boholano" },
	{ value: "bolinao", label: "Bolinao" },
	{ value: "bontoc", label: "Bontoc" },
	{ value: "buhid", label: "Buhid" },
	{ value: "butuanon", label: "Butuanon" },
	{ value: "caluyanon", label: "Caluyanon" },
	{ value: "capiznon", label: "Capiznon" },
	{ value: "caviteño", label: "Caviteño" },
	{ value: "cebuano", label: "Cebuano" },
	{ value: "cotabateño", label: "Cotabateño" },
	{ value: "davaoeño", label: "Davaoeño" },
	{ value: "ermiteño", label: "Ermiteño" },
	{ value: "ga'dang", label: "Ga'dang" },
	{ value: "gaddang", label: "Gaddang" },
	{ value: "hanunoo", label: "Hanunoo" },
	{ value: "higaonon", label: "Higaonon" },
	{ value: "ibaloi", label: "Ibaloi" },
	{ value: "ibanag", label: "Ibanag" },
	{ value: "ifugaoamganad", label: "Ifugao, Amganad" },
	{ value: "ifugaobatad", label: "Ifugao, Batad" },
	{ value: "ifugaomayoyao", label: "Ifugao, Mayoyao" },
	{ value: "ifugaotuwali", label: "Ifugao, Tuwali" },
	{ value: "ikalahankayapa", label: "Ikalahan, Kayapa" },
	{ value: "ikalahankeley-i", label: "Ikalahan, Keley-i" },
	{ value: "ikalahantinoc", label: "Ikalahan, Tinoc" },
	{ value: "illanun", label: "Illanun" },
	{ value: "ilocano", label: "Ilocano" },
	{ value: "ilonggo", label: "Ilonggo" },
	{ value: "ilongot", label: "Ilongot" },
	{ value: "indianfilipinos", label: "Indian Filipinos" },
	{ value: "inonhan", label: "Inonhan" },
	{ value: "iraya", label: "Iraya" },
	{ value: "isinai", label: "Isinai" },
	{ value: "isneg", label: "Isneg" },
	{ value: "itnegbanao", label: "Itneg, Banao" },
	{ value: "itnegbinongan", label: "Itneg, Binongan" },
	{ value: "itneginlaod", label: "Itneg, Inlaod" },
	{ value: "itnegmaeng", label: "Itneg, Maeng" },
	{ value: "itnegmasadiit", label: "Itneg, Masadiit" },
	{ value: "itnegmoyadan", label: "Itneg, Moyadan" },
	{ value: "ivatan", label: "Ivatan" },
	{ value: "japanesefilipinos", label: "Japanese Filipinos" },
	{ value: "kagayanen", label: "Kagayanen" },
	{ value: "kalagan", label: "Kalagan" },
	{ value: "kalagankagan", label: "Kalagan, Kagan" },
	{ value: "kalagantagakaulo", label: "Kalagan, Tagakaulo" },
	{ value: "kalingabutbut", label: "Kalinga, Butbut" },
	{ value: "kalingalimos", label: "Kalinga, Limos" },
	{ value: "kalingalowertanudan", label: "Kalinga, Lower Tanudan" },
	{ value: "kalingalubuagan", label: "Kalinga, Lubuagan" },
	{ value: "kalingamabakavalley", label: "Kalinga, Mabaka Valley" },
	{ value: "kalingamadukayang", label: "Kalinga, Madukayang" },
	{ value: "kalingasouthern", label: "Kalinga, Southern" },
	{ value: "kalingauppertanudan", label: "Kalinga, Upper Tanudan" },
	{ value: "kamayo", label: "Kamayo" },
	{ value: "kankanaeynorthern", label: "Kankanaey, Northern" },
	{ value: "kankanaeysouthern", label: "Kankanaey, Southern" },
	{ value: "kapampangan", label: "Kapampangan" },
	{ value: "karao", label: "Karao" },
	{ value: "kasiguranin", label: "Kasiguranin" },
	{ value: "kinaray-a", label: "Kinaray-a" },
	{ value: "koreanfilipinos", label: "Korean Filipinos" },
	{ value: "magahat", label: "Magahat" },
	{ value: "maguindanaon", label: "Maguindanaon" },
	{ value: "malaweg", label: "Malaweg" },
	{ value: "malaynon", label: "Malaynon" },
	{ value: "mamanwa", label: "Mamanwa" },
	{ value: "mandayasangab", label: "Mandaya, Sangab" },
	{ value: "mandayacataelano", label: "Mandaya, Cataelano" },
	{ value: "mandayakaraga", label: "Mandaya, Karaga" },
	{ value: "mandayamansaka", label: "Mandaya, Mansaka" },
	{ value: "manguwangan", label: "Manguwangan" },
	{ value: "manoboagusan", label: "Manobo, Agusan" },
	{ value: "manoboata", label: "Manobo, Ata" },
	{ value: "manobocinamiguin", label: "Manobo, Cinamiguin" },
	{ value: "manobocotabato", label: "Manobo, Cotabato" },
	{ value: "manobodibabawon", label: "Manobo, Dibabawon" },
	{ value: "manoboilianen", label: "Manobo, Ilianen" },
	{ value: "manobomatigsalug", label: "Manobo, Matigsalug" },
	{ value: "manoboobo", label: "Manobo, Obo" },
	{ value: "manobopulangiyen", label: "Manobo, Pulangiyen" },
	{ value: "manoborajahkabunsuwan", label: "Manobo, Rajah Kabunsuwan" },
	{ value: "manobosarangani", label: "Manobo, Sarangani" },
	{ value: "manobotalaandig", label: "Manobo, Talaandig" },
	{ value: "manobowesternbukidnon", label: "Manobo, Western Bukidnon" },
	{ value: "maranao", label: "Maranao" },
	{ value: "masbatesorsogon", label: "Masbate, Sorsogon" },
	{ value: "masbateño", label: "Masbateño" },
	{ value: "palawanobrooke'spoint", label: "Palawano, Brooke's Point" },
	{ value: "palawanocentral", label: "Palawano, Central" },
	{ value: "palawanosouthwest", label: "Palawano, Southwest" },
	{ value: "palaweñoagutaynon", label: "Palaweño, Agutaynon" },
	{ value: "palaweñocuyonon", label: "Palaweño, Cuyonon" },
	{ value: "palaweñomolbog", label: "Palaweño, Molbog" },
	{ value: "pangasinense", label: "Pangasinense" },
	{ value: "paranan", label: "Paranan" },
	{ value: "porohanon", label: "Porohanon" },
	{ value: "ratagnon", label: "Ratagnon" },
	{ value: "romblomanon", label: "Romblomanon" },
	{ value: "samaabaknon", label: "Sama, Abaknon" },
	{ value: "samapangutaran", label: "Sama, Pangutaran" },
	{ value: "samasamalisland", label: "Sama, Samal Island" },
	{ value: "sambalbolinao", label: "Sambal, Bolinao" },
	{ value: "sambalbotolan", label: "Sambal, Botolan" },
	{ value: "sambaltina", label: "Sambal, Tina" },
	{ value: "sangil", label: "Sangil" },
	{ value: "sangir", label: "Sangir" },
	{ value: "sinauna", label: "Sinauna" },
	{ value: "spanishfilipinos", label: "Spanish Filipinos" },
	{ value: "subanencentral", label: "Subanen, Central" },
	{ value: "subanenkolibugan", label: "Subanen, Kolibugan" },
	{ value: "subanenlapuyan", label: "Subanen, Lapuyan" },
	{ value: "subanennorthern", label: "Subanen, Northern" },
	{ value: "subanenwestern", label: "Subanen, Western" },
	{ value: "sulod", label: "Sulod" },
	{ value: "surigaonon", label: "Surigaonon" },
	{ value: "t'boli", label: "T'boli" },
	{ value: "tadyawan", label: "Tadyawan" },
	{ value: "tagabawa", label: "Tagabawa" },
	{ value: "tagalog", label: "Tagalog" },
	{ value: "tagbanwa", label: "Tagbanwa" },
	{ value: "tagbanwacalamian", label: "Tagbanwa, Calamian" },
	{ value: "tagbanwacentral", label: "Tagbanwa, Central" },
	{ value: "tasaday", label: "Tasaday" },
	{ value: "tau'tbato", label: "Tau't Bato" },
	{ value: "tausug", label: "Tausug" },
	{ value: "tawbuideastern", label: "Tawbuid, Eastern" },
	{ value: "tawbuidwestern", label: "Tawbuid, Western" },
	{ value: "ternateño", label: "Ternateño" },
	{ value: "tiruray", label: "Tiruray" },
	{ value: "tsinoycantonese", label: "Tsinoy, Cantonese" },
	{ value: "tsinoyfujianese", label: "Tsinoy, Fujianese" },
	{ value: "tsinoymandarin", label: "Tsinoy, Mandarin" },
	{ value: "waray", label: "Waray" },
	{ value: "waraysorsogon", label: "Waray Sorsogon" },
	{ value: "yakan", label: "Yakan" },
	{ value: "yogad", label: "Yogad" },
	{ value: "zamboangueño", label: "Zamboangueño" },
	// { value: "otherethnicity", label: "Others, specify" },
];

export const immunizations = [
	{
		label: "BCG",
	},
	{
		label: "Hepatitis B",
	},
	{
		label: "Pentavalent Vaccine (DPT-HepB-Hib)",
	},
	{
		label: "Oral Polio Vaccine (OPV)",
	},
	{
		label: "Inactivated Polio Vaccine (IPV)",
	},
	{
		label: "Pneumococcal Conjugate Vaccine (PCV)",
	},
	{
		label: "Measles, Mumps, Rubella (MMR)",
	},
	{
		label: "PPV23 Pneumococcal Pneumococcal Polyssacharide Vaccine",
	},
	{
		label: "Influenza Vaccine",
	},
	{
		label: "Human Papilloma Vaccine",
	},
];

export const disabilities = [
	{
		value: "disone",
		label: "1 Total blindness",
	},
	{
		value: "distwo",
		label: "2 Partial blindness",
	},
	{
		value: "disthree",
		label: "3 Low vision",
	},
	{
		value: "disfour",
		label: "4 Totally deaf",
	},
	{
		value: "disfive",
		label: "5 Partially deaf",
	},
	{
		value: "dissix",
		label: "6 Oral defect",
	},
	{
		value: "disseven",
		label: "7 One hand",
	},
	{
		value: "diseight",
		label: "8 No hands",
	},
	{
		value: "disnine",
		label: "9 One leg",
	},
	{
		value: "disten",
		label: "10 No legs",
	},
	{
		value: "diseleven",
		label: "11 Mild Cerebral palsy",
	},
	{
		value: "distwelve",
		label: "12 Severe Cerebral palsy",
	},
	{
		value: "disfourteen",
		label: "13 Mentally ill",
	},
	{
		value: "dissixteen",
		label: "14 Multiple impairment",
	},
	/* {
		value: "disseventeen",
		label: "15 Others, specify",
	}, */
];

export const crimes = [
	{
		value: "cone",
		label: "1 Theft",
	},
	{
		value: "ctwo",
		label: "2 Robbery",
	},
	{
		value: "cthree",
		label: "3 Rape",
	},
	{
		value: "cfour",
		label: "4 Physical injury",
	},
	{
		value: "cfive",
		label: "5 Carnapping",
	},
	{
		value: "csix",
		label: "6 Cattle rustling",
	},
	/* {
		value: "cseven",
		label: "7 Others, specify",
	}, */
];

export const where_crimes = [
	{ value: "locone", label: "1 Within the barangay" },
	{
		value: "loctwo",
		label: "2 Outside the barangay but within municipality/city",
	},
	{
		value: "locthree",
		label: "3 Outside the municipality/city but within the province",
	},
	{ value: "locfour", label: "4 Outside the province" },
];

export const vax_status_list = [
	{
		value: "1st",
		label: "Partially Vaccinated (1st Primary Dose Only)",
	},
	{
		value: "2nd",
		label: "Fully Vaccinated (1st & 2nd Primary Dose or Single Dose of J&J)",
	},
	{
		value: "3rd",
		label: "Fully Vaccinated with 1st Booster",
	},
	{
		value: "4th",
		label: "Fully Vaccinated with 2nd Booster",
	},
	{
		value: "unvax",
		label: "Unvaccinated",
	},
];

export const types_disease = [
	{
		value: "commune",
		label: "Communicable",
	},
	{
		value: "noncom",
		label: "Non-Communicable",
	},
];

export const opvs = [
	{ value: "opv1", label: "OPV1" },
	{ value: "opv2", label: "OPV2" },
	{ value: "opv3", label: "OPV3" },
	{ value: "opv4", label: "OPV4" },
];
export const pentavalents = [
	{ value: "penta1", label: "Penta1" },
	{ value: "penta2", label: "Penta2" },
	{ value: "penta3", label: "Penta3" },
];

export const mvcs = [
	{ value: "mcv1", label: "MCV1" },
	{ value: "mcv2", label: "MCV2" },
];
export const hpvs = [
	{ value: "hpv1", label: "HPV1" },
	{ value: "hpv2", label: "HPV2" },
];

export const marital_status_lists = [
	{
		value: "ms_single",
		label: "Single",
	},
	{
		value: "ms_married",
		label: "Married",
	},
	{
		value: "ms_widowed",
		label: "Widowed",
	},
	{
		value: "ms_separated",
		label: "Divorced/Separated",
	},
	{
		value: "ms_in",
		label: "Common-law/Live-in",
	},
	{
		value: "ms_unknown",
		label: "Unknown",
	},
];

export const tribes = [
	{
		value: "ip",
		label: "IP's",
	},
	{
		value: "non_ip",
		label: "NON-IP's",
	},
	{
		value: "other_ip",
		label: "Other",
	},
];

export const ip_tribes = [
	{
		value: "blaan",
		label: "B'laan",
	},
	{
		value: "tboli",
		label: "T'Boli",
	},
	{
		value: "tagakaulo",
		label: "Tagakaulo",
	},
	{
		value: "kalagan",
		label: "Kalagan",
	},
	{
		value: "manobo",
		label: "Manobo",
	},
	{
		value: "ubo",
		label: "Ubo",
	},
	{
		value: "moro",
		label: "Moro",
	},
	{
		value: "others",
		label: "Others",
	},
];

export const non_ip_tribes = [
	{
		label: "Cebuano",
		value: "cebuano",
	},
	{
		label: "Bisaya",
		value: "bisaya",
	},
	{
		label: "Hiligaynon, Ilonggo",
		value: "ilonggo",
	},
	{
		label: "Ilocano",
		value: "ilocano",
	},
	{
		label: "Maguindanao",
		value: "maguindanao",
	},
	{
		label: "Others",
		value: "others",
	},
];

export const choices_yes_no = [
	{
		value: "yes",
		label: "Yes",
	},
	{
		value: "no",
		label: "No",
	},
];

export const phic_member_types = [
	{
		value: "direct",
		label: "Direct Contributor",
	},
	{
		value: "indirect",
		label: "Indirect Contributor",
	},
];
export const direct_contributor_types = [
	{
		value: "1",
		label: `Employed Private`,
	},
	{
		value: "2",
		label: `Employed Government`,
	},
	{
		value: "3",
		label: `Professional Practitioner`,
	},
	{
		value: "4",
		label: `Self-Earning Individual`,
	},
	{
		value: "5",
		label: `Kasambahay`,
	},
	{
		value: "6",
		label: `Migrant Worker`,
	},
	{
		value: "7",
		label: `Lifetime Member`,
	},
	{
		value: "8",
		label: `Filipinos with Dual Citizenship/Living Abroad`,
	},
	{
		value: "9",
		label: `Foreign National`,
	},
	{
		value: "10",
		label: `Family Driver`,
	},
	{
		value: "11",
		label: `Dependent Beneficiary`,
	},
];
export const indirect_contributor_types = [
	{
		value: "1",
		label: `Listahanan`,
	},
	{
		value: "2",
		label: `4Ps/MCCT`,
	},
	{
		value: "3",
		label: `Senior Citizen`,
	},
	{
		value: "4",
		label: `PAMANA`,
	},
	{
		value: "5",
		label: `KIA/KIPO`,
	},
	{
		value: "6",
		label: `MLGU Sponsored`,
	},
	{
		value: "7",
		label: `PLGU Sponsored`,
	},
	{
		value: "8",
		label: `NGA Sponsored`,
	},
	{
		value: "9",
		label: `Private Sponsored`,
	},
	{
		value: "10",
		label: `PWD`,
	},
	{
		value: "11",
		label: `Bangsamoro/Normalization`,
	},
	{
		value: "12",
		label: `Dependent Beneficiary`,
	},
];

export const nutritional_status = [
	{ value: "suw", label: "Severely Underweight" },
	{ value: "uw", label: "Underweight" },
	{ value: "norm", label: "Normal" },
	{ value: "ow", label: "Overweight" },
	{ value: "obese", label: "Obese" },
];

export const nutritional_status_categories = [
	{ value: "old", label: "Old" },
	{ value: "new", label: "New" },
];

export const children_nutrition_for_wt = [
	{
		label: "Severely Wasted",
		value: "sw",
	},
	{
		label: "Wasted",
		value: "w",
	},
	{
		label: "Normal",
		value: "norm",
	},
	{
		label: "Overweight",
		value: "ow",
	},
	{
		label: "Obese",
		value: "obese",
	},
];

export const children_nutrition_for_age = [
	{
		label: "Severely Stunted",
		value: "ss",
	},
	{
		label: "Stunted",
		value: "stun",
	},
	{
		label: "Normal",
		value: "norm",
	},
	{
		label: "Tall",
		value: "tall",
	},
];

export const religion_choices = [
	{
		value: "Roman Catholic",
		label: "Roman Catholic",
	},
	{
		value: "Islam",
		label: "Islam",
	},
	{
		value: "Iglesia Ni Cristo",
		label: "Iglesia Ni Cristo",
	},
	{
		value: "Protestant",
		label: "Protestant",
	},
	{
		value: "None",
		label: "None",
	},
	{
		value: "Others",
		label: "Others",
	},
];
